import { render } from "./MiNTNewsTop.vue?vue&type=template&id=652256fa&scoped=true"
const script = {}

import "./MiNTNewsTop.vue?vue&type=style&index=0&id=652256fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652256fa"]])

export default __exports__